<template>
  <van-tabbar v-model="active">
    <van-tabbar-item to="/" icon="home-o">首页</van-tabbar-item>
    <van-tabbar-item icon="search" dot>工作</van-tabbar-item>
    <van-tabbar-item>
      <span>通讯录</span>
      <bv-icon slot="icon" icon-class="contacts" />
    </van-tabbar-item>
    <van-tabbar-item to="/settings">
      <span>设置</span>
      <bv-icon slot="icon" icon-class="user" />
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
import { Tabbar, TabbarItem } from 'vant'

export default {
  name: 'Tabbar',
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem
  },
  data() {
    return {
      active: 0
    }
  },
  watch: {
    active(value) {
      this.$store.dispatch('app/setActiveTab', value)
    },
    '$store.getters.activeTab'(value) {
      this.active = value
    }
  }
}
</script>

